import { createFileRoute } from "@tanstack/react-router";

import { PrivacyPage } from "@/components/marketing/privacy-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/privacy")({
  head: () => pageHead("privacy"),
  component: PrivacyPage,
});
